export default function useDataConfiguration({ to_person, role }) {
  return {
    variables: { to_person, role },
    pause: !to_person,
  }
}
